export const SUMMARY_EXCLUDE_DATA = ['project', 'phase', 'costcode', 'serviceLocation', 'date'];

export const TYPE_MAP = {
  Project: ['work', 'overtime'],
  Service: ['service'],
  Break: ['break'],
};

export const DEFAULT_ENABLED_FILTERS = {
  project: true,
  phase: true,
  costcode: true,
  serviceLocation: true,
  date: true,
  approved: true,
  unapproved: true,
  notes: true,
};

export const DEFAULT_WORK_TYPE = new Set(['work', 'service', 'overtime', 'break', 'pto']);